export enum UserWalletOperationTypeEnum {
    None = 0,
    RiderTransferFromXpressWallet = 1,
    CustomerPayment = 2,
    RiderEarning = 3,
    TopUpWallet = 4,
    PayOut = 5,
    RiderCommission = 6,
    CustomerTip = 7,
    DailyServiceFee = 8,
    PayOutPending = 9,
    PayOutFee = 10,
    Refund = 11,
    PayOutRestore = 12,
    CancellationFee = 13,
    WaitingFee = 14,
    PayOutFeeRestore = 15,
    WaitingFeeRiderEarning = 16,
    CancellationFeeRiderEarning = 17,
	WithholdingTax = 18,
	ReferralEarning = 19,
    PrizeMoney = 20,
    RiderServiceFee = 21,
    CashRiderEarning = 22,
    RiderTip = 23,
    XpressIncentive = 24,
    RiderTransferToCashWallet = 25,
    PayOutToPaymentCard = 26,
    TopUpFromPaymentCard = 27
}
